import { render } from "./MapBox.vue?vue&type=template&id=22916e4a&scoped=true"
import script from "./MapBox.vue?vue&type=script&lang=js"
export * from "./MapBox.vue?vue&type=script&lang=js"

import "./MapBox.vue?vue&type=style&index=0&id=22916e4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22916e4a"]])

export default __exports__